var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "lateral-menu" } },
    [
      _c("router-link", { attrs: { to: "/" } }, [
        _c("img", {
          staticClass: "image",
          attrs: { src: require("@/assets/gps_logo.png"), width: "270px" },
        }),
      ]),
      _c("hr", { staticClass: "is-marginless" }),
      _c(
        "b-menu",
        { attrs: { activable: false } },
        [
          _c(
            "b-menu-list",
            { attrs: { label: _vm.$t("sidebar.general") } },
            [
              _vm.authorize("/maps")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/maps" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "map-marker-alt",
                              type: "is-danger",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.map"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/import-settings")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/import-settings" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "database",
                              type: "is-warning",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.edi"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/shipping-instructions")
                ? _c(
                    "b-menu-item",
                    {
                      attrs: {
                        tag: "router-link",
                        to: "/shipping-instructions",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "tree",
                              type: "is-primary",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.natural_rubber"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
          _vm.selectedPlant
            ? _c(
                "b-menu-list",
                { attrs: { label: _vm.$t("sidebar.plant") } },
                [
                  _vm.authorize({
                    name: "plant-production",
                    params: { plant_id: _vm.selectedPlant },
                  })
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "router-link",
                            to: {
                              name: "plant-production",
                              params: { plant_id: _vm.selectedPlant },
                            },
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "industry",
                                  type: "is-info",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.production"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize({
                    name: "plant-loads",
                    params: { plant_id: _vm.selectedPlant },
                  })
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "router-link",
                            to: {
                              name: "plant-loads",
                              params: { plant_id: _vm.selectedPlant },
                            },
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "truck-moving",
                                  type: "is-dark",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.loads"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize({
                    name: "plant-stock",
                    params: { plant_id: _vm.selectedPlant },
                  })
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "router-link",
                            to: {
                              name: "plant-stock",
                              params: { plant_id: _vm.selectedPlant },
                            },
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "boxes",
                                  type: "is-warning",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.stock"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize({
                    name: "plant-scans",
                    params: { plant_id: _vm.selectedPlant },
                  })
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "router-link",
                            to: {
                              name: "plant-scans",
                              params: { plant_id: _vm.selectedPlant },
                            },
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "barcode",
                                  type: "is-danger",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.scans"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.selectedPlant &&
                  ["C", "D"].includes(_vm.selectedPlant.charAt(2))
                    ? _c(
                        "b-menu-item",
                        {
                          attrs: {
                            tag: "a",
                            target: "_blank",
                            href: "https://frgps.sharepoint.com/sites/Subcontractor",
                          },
                        },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "external-link-alt",
                                  type: "is-purple",
                                  size: "is-small",
                                },
                              }),
                              [_vm._v("Sharepoint")],
                            ],
                            2
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _c(
            "b-menu-list",
            { attrs: { label: _vm.$t("sidebar.administration") } },
            [
              _vm.authorize("/dashboard/:id")
                ? _c(
                    "b-menu-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function (props) {
                              return [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "chart-bar",
                                    type: "is-blue",
                                    size: "is-small",
                                  },
                                }),
                                _c("span", { staticClass: "has-text-grey" }, [
                                  _vm._v("Dashboard"),
                                ]),
                                _c("b-icon", {
                                  staticClass: "is-pulled-right",
                                  attrs: {
                                    icon: props.expanded
                                      ? "caret-down"
                                      : "caret-up",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1508260553
                      ),
                    },
                    _vm._l(_vm.allDashboardsName, function (item, index) {
                      return _c(
                        "b-menu-item",
                        {
                          key: index,
                          attrs: {
                            tag: "router-link",
                            to: { name: "dashboard", params: { id: index } },
                          },
                        },
                        [
                          _c("template", { slot: "label" }, [
                            _c("span", { staticClass: "has-text-grey" }, [
                              _vm._v(_vm._s(item.name.replaceAll("_", " "))),
                            ]),
                          ]),
                        ],
                        2
                      )
                    }),
                    1
                  )
                : _vm._e(),
              _vm.authorize("/plants")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/plants", exact: "" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "warehouse",
                              type: "is-dark",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.plants"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/customers")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/customers" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "address-card",
                              type: "is-info",
                              pack: "far",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.customers"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/closures")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/closures" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "door-closed",
                              type: "is-info",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.closures"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/sapinventory")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/sapinventory" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "warehouse",
                              type: "is-info",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.sap_inventory"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/devices")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/devices" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "mobile-alt",
                              type: "is-grey",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.devices"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "b-menu-item",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "label",
                      fn: function (props) {
                        return [
                          _c("b-icon", {
                            attrs: {
                              icon: "id-card",
                              type: "is-purple",
                              pack: "far",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v("Identity"),
                          ]),
                          _c("b-icon", {
                            staticClass: "is-pulled-right",
                            attrs: {
                              icon: props.expanded ? "caret-down" : "caret-up",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                },
                [
                  _vm.authorize("/users")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/users" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "user",
                                  type: "is-info",
                                  pack: "far",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.users"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/groups")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/groups" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "users",
                                  type: "is-primary",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.groups"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.authorize("/roles")
                    ? _c(
                        "b-menu-item",
                        { attrs: { tag: "router-link", to: "/roles" } },
                        [
                          _c(
                            "template",
                            { slot: "label" },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "user-shield",
                                  type: "is-warning",
                                  size: "is-small",
                                },
                              }),
                              _c("span", { staticClass: "has-text-grey" }, [
                                _vm._v(_vm._s(_vm.$t("sidebar.roles"))),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.authorize("/movements")
                ? _c(
                    "b-menu-item",
                    {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "label",
                            fn: function (props) {
                              return [
                                _c("b-icon", {
                                  attrs: {
                                    icon: "tachometer-alt",
                                    type: "is-purple",
                                    size: "is-small",
                                  },
                                }),
                                _c("span", { staticClass: "has-text-grey" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("sidebar.production_data"))
                                  ),
                                ]),
                                _c("b-icon", {
                                  staticClass: "is-pulled-right",
                                  attrs: {
                                    icon: props.expanded
                                      ? "caret-down"
                                      : "caret-up",
                                  },
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1498063191
                      ),
                    },
                    [
                      _vm.authorize("/movements")
                        ? _c(
                            "b-menu-item",
                            { attrs: { tag: "router-link", to: "/movements" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "truck-ramp-box",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("sidebar.production_movements")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/inventory")
                        ? _c(
                            "b-menu-item",
                            { attrs: { tag: "router-link", to: "/inventory" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "boxes-stacked",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("sidebar.production_inventory")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/stock")
                        ? _c(
                            "b-menu-item",
                            { attrs: { tag: "router-link", to: "/stock" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "box",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("sidebar.production_stock"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/booking")
                        ? _c(
                            "b-menu-item",
                            { attrs: { tag: "router-link", to: "/booking" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "calendar-days",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("sidebar.production_bookings")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/forecast")
                        ? _c(
                            "b-menu-item",
                            { attrs: { tag: "router-link", to: "/forecast" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "clock",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("sidebar.production_forecast")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/employees")
                        ? _c(
                            "b-menu-item",
                            { attrs: { tag: "router-link", to: "/employees" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "users",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("sidebar.production_employees")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/employeeSchedule")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: {
                                tag: "router-link",
                                to: "/employeeSchedule",
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "calendar",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("sidebar.production_schedule")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/bonusManagement")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: {
                                tag: "router-link",
                                to: "/bonusManagement",
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "money-bill-1",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("sidebar.bonus_management"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/bonusCalculator")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: {
                                tag: "router-link",
                                to: "/bonusCalculator",
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "calculator",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("sidebar.bonus_calculator"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/ncDeclaration")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: {
                                tag: "router-link",
                                to: "/ncDeclaration",
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "circle-xmark",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("sidebar.nc_declaration"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/ncrInspection")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: {
                                tag: "router-link",
                                to: "/ncrInspection",
                              },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "circle-exclamation",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("sidebar.ncr_inspection"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/accident")
                        ? _c(
                            "b-menu-item",
                            { attrs: { tag: "router-link", to: "/accident" } },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "person-falling-burst",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(_vm._s(_vm.$t("sidebar.accident"))),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/actionPlan")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: { tag: "router-link", to: "/actionPlan" },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "calendar-check",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(
                                      _vm._s(_vm.$t("sidebar.actionPlan"))
                                    ),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/targetStock")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: { tag: "router-link", to: "/targetStock" },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "crosshairs",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(_vm._s("Target Stock")),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                      _vm.authorize("/worldStock")
                        ? _c(
                            "b-menu-item",
                            {
                              attrs: { tag: "router-link", to: "/worldStock" },
                            },
                            [
                              _c(
                                "template",
                                { slot: "label" },
                                [
                                  _c("b-icon", {
                                    attrs: {
                                      icon: "globe",
                                      type: "is-info",
                                      size: "is-small",
                                    },
                                  }),
                                  _c("span", { staticClass: "has-text-grey" }, [
                                    _vm._v(_vm._s("World Stock")),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.authorize("/upload")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/upload" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "upload",
                              type: "is-success",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.upload"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/sap")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/sap" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "wrench",
                              type: "is-danger",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.sap"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/enduser-declaration-admin")
                ? _c(
                    "b-menu-item",
                    {
                      attrs: {
                        tag: "router-link",
                        to: "/enduser-declaration-admin",
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "scroll",
                              type: "is-link",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.pickup_management"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/enduser-declaration-admin")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/closure-schedule" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "door-closed",
                              type: "is-warning",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t("pages.closure_schedule.sidebar_link")
                              )
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/distribution")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/distribution" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "diagram-project",
                              type: "is-link",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v("Distribution"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/shipments")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/shipments" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "truck",
                              type: "is-link",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v("Shipments Distribution"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/crate-peremption")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/crate-peremption" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "hourglass-end",
                              type: "is-dark",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.barcode_reminder"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/report")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/report" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "file-alt",
                              type: "is-primary",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.report"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/customer-forecast")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/customer-forecast" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "chart-area",
                              type: "is-black",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.customer_forecast"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/clientForecast")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/clientForecast" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "clock",
                              type: "is-info",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.client_forecast"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/new-crates")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/new-crates" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "cube",
                              type: "is-yellow",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.new_crates"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
              _vm.authorize("/admin-panel")
                ? _c(
                    "b-menu-item",
                    { attrs: { tag: "router-link", to: "/admin-panel" } },
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _c("b-icon", {
                            attrs: {
                              icon: "users-cog",
                              type: "is-yellow",
                              size: "is-small",
                            },
                          }),
                          _c("span", { staticClass: "has-text-grey" }, [
                            _vm._v(_vm._s(_vm.$t("sidebar.admin_panel"))),
                          ]),
                        ],
                        1
                      ),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }